module.exports = __webpack_public_path__ + "static/img/core-eng-mb-bg.7b90689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-eng-mb-bg.png
// module id = X9iX
// module chunks = 0